<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-08-29 18:40:28
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-08-31 14:15:47
 * @FilePath: \vue-privilege-routing\src\pages\login\register.vue
-->
<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-23 10:26:12
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-08-29 16:27:15
 * @FilePath: \vue-privilege-routing\src\pages\login\index.vue
-->
<template>
  <div id="register-back">
    <div class="register-title">
      <span>欢迎注册</span>
    </div>
    <div class="register-form">
      <el-form
        :rules="rules"
        ref="registerForm"
        :model="registerForm"
        label-width="80px"
        v-loading="loading"
        element-loading-text="正在登录..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form-item label="手机号码" prop="mobileNum">
          <el-input v-model="registerForm.mobileNum"></el-input>
        </el-form-item>
        <el-form-item label="设置昵称">
          <el-input v-model="registerForm.username"></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input v-model="registerForm.password"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="password_two">
          <el-input v-model="registerForm.password_two"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding-left: 20px;">
        <el-button type="primary" @click="registerSubmit"
          >点 击 注 册</el-button
        >
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="40%"
      hight="40%"
      :before-close="handleClose"
    >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { doLogin, checkLogin, registerSubmit } from '../../api'

export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      const reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/
      setTimeout(() => {
        if (reg.test(value)) {
          callback()
        } else {
          callback(new Error('请请正确输入手机号码!'))
        }
      }, 100)
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        // if (this.registerForm.password !== '') {
        //   this.$refs.registerForm.validateField('password')
        // }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      units: [],
      rolesLists: [],
      account: '',
      password: '',
      roleId: '',
      dialogVisible: true,

      registerForm: {
        mobileNum: '',
        username: '',
        password: '',
        password_two: ''
      },

      rules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 16,
            message: '长度在 6 到 16 个字符',
            trigger: 'blur'
          },
          { validator: validatePass, trigger: 'blur' }
        ],
        password_two: [
          { required: true, message: '两次输入的密码不一致', trigger: 'blur' },
          {
            min: 6,
            max: 16,
            message: '长度在 6 到 16 个字符',
            trigger: 'blur'
          },
          { validator: validatePass2, trigger: 'blur', required: true }
        ],
        mobileNum: [
          {
            required: true,
            trigger: 'blur',
            validator: checkPhone
          }
        ]
      }
    }
  },
  methods: {
    

    async registerSubmit() {
      this.dialogVisible = false
      await this.$refs.registerForm.validate(valid => {
        console.log(valid)
        if (valid) {
          console.log('点击了确认要注册的按钮', this.registerForm)

          this.loading = true
          let result = registerSubmit(this.registerForm)
          this.loading = false
          this.$router.push('http://localhost:8080/login')
        } else {
          this.$message.error('字段不能为空')
          return false
        }
      })
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },

    
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
#register-back {
  .register-title {
    text-align: center;
    height: 120px;
    line-height: 120px;
    border-bottom: 1px solid rgb(219, 218, 218);
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.5);

    span {
      font-size: 50px;
    }
  }
  .register-form {
    width: 20%;
    margin: 260px 0px 0px 700px;
  }
  .el-button {
    margin-top: 10px;
    width: 346px;
  }
}
</style>
